import { render, staticRenderFns } from "./AnimationNumber.vue?vue&type=template&id=35d0cc9d&"
import script from "./AnimationNumber.vue?vue&type=script&lang=js&"
export * from "./AnimationNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports